import React from 'react';

/** Percorso di cura: completati / prossimo / futuri. */
export function CareTimeline({ steps = [], className = '' }) {
  return (
    <ol className={`space-y-3 ${className}`}>
      {steps.map((step, idx) => {
        const status = step.status || (step.done ? 'done' : step.current ? 'current' : 'upcoming');
        return (
          <li key={step.id || idx} className="flex gap-3">
            <span
              className={[
                'mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-vc-xs font-semibold',
                status === 'done' && 'bg-vc-slot text-white',
                status === 'current' && 'bg-vc-primary text-white',
                status === 'upcoming' && 'bg-vc-surface-2 text-vc-ink-3'
              ].filter(Boolean).join(' ')}
              aria-hidden
            >
              {idx + 1}
            </span>
            <div className="min-w-0">
              <p className="text-vc-md font-medium text-vc-ink">{step.title || step.label}</p>
              {step.description && (
                <p className="text-vc-sm text-vc-ink-2">{step.description}</p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
